















import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapGetters } from 'vuex';
import { Action } from '@/requests/mainApi';
import UiButton from '@/components/ui/UiButton.vue';

interface Data {}

interface Methods {
  outsideClick: (e: Event) => void;
  goToMainAction: () => void;
}

interface Computed {
  actionMain: Action,
}

interface Props {
  close: () => void | null;
}

export default Vue.extend({
  name: 'MainActionModal',
  components: {
    UiButton,
  },
  props: {
    close: null,
  },
  methods: {
    outsideClick(e: MouseEvent) {
      if (!this.$refs.modal || (this.$refs.modal as HTMLElement).contains(e.target as HTMLElement)) {
        return;
      }
      this.close();
    },
    goToMainAction() {
      window.open(this.actionMain.url, '_blank');
    },
  },
  computed: {
    ...mapGetters('profile', ['actionMain']),
  },
  mounted() {
    document.addEventListener('mousedown', this.outsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.outsideClick);
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
